'use strict';
import { API_URL, RESULTS_PER_PAGE, API_KEY } from './config';
import { AJAX, generateRecipeObject } from './helper';

export const state = {
  recipe: {},
  search: {
    query: '',
    results: [],
    resultsPerPage: RESULTS_PER_PAGE,
    page: 1,
  },
  bookmarks: [],
};

init();

function init() {
  const localBookmarks = localStorage.getItem('bookmarks');
  if (!localBookmarks) return;
  state.bookmarks = JSON.parse(localBookmarks);
}

export async function getRecipe() {
  try {
    const id = window.location.hash.slice(1);
    if (!id) return;
    const url = `${API_URL}/${id}`;
    const data = await AJAX(url);
    const { recipe } = data.data;

    state.recipe = generateRecipeObject(recipe);

    // Set bookmark
    state.bookmarks.some((bookmark) => {
      bookmark.id === state.recipe.id ? (state.recipe.bookmarked = true) : (state.recipe.bookmark = false);
    });
  } catch (err) {
    throw err;
  }
}

export async function getSearchResults(query) {
  try {
    state.search.query = query;
    const data = await AJAX(`${API_URL}?search=${query}&key=${API_KEY}`);
    const { recipes } = data.data;
    state.search.results = recipes.map((recipe) => {
      return {
        id: recipe.id,
        title: recipe.title,
        publisher: recipe.publisher,
        imageURL: recipe.image_url,
      };
    });
  } catch (err) {
    throw err;
  }
}

export function getSearchResultsOfPage(page = state.search.page) {
  state.search.page = page;
  const start = (page - 1) * state.search.resultsPerPage;
  const end = page * state.search.resultsPerPage;
  return state.search.results.slice(start, end);
}

export function resetPage() {
  state.search.page = 1;
}

export function updateServings(newServings) {
  state.recipe.ingredients.forEach((ing) => {
    ing.quantity = (ing.quantity * newServings) / state.recipe.servings;
  });
  state.recipe.servings = newServings;
}

function setBookmarkPersistence() {
  localStorage.setItem('bookmarks', JSON.stringify(state.bookmarks));
}

export function addBookmark(recipe) {
  state.bookmarks.push(recipe);
  recipe.bookmarked = true;
  setBookmarkPersistence();
}

export function removeBookmark(id) {
  const index = state.bookmarks.findIndex((bookmark) => bookmark.id === id);
  state.bookmarks.splice(index, 1);
  state.recipe.bookmarked = false;
  setBookmarkPersistence();
}

function clearBookmarksFromLocalStorage() {
  localStorage.clear('bookmarks');
}

export async function uploadRecipe(newRecipe) {
  try {
    const ingredients = Object.entries(newRecipe)
      .filter((el) => el[0].startsWith('ingredient') && el[1] !== '')
      .map((ing) => {
        if (ing[1].split(',').length !== 3) throw new Error('Wrong Ingredient format! Please use "x,y,z".');

        const [quantity, unit, description] = ing[1].split(',');
        return { quantity: quantity ? +quantity : null, unit, description: description.trim() };
      });

    const uploadData = {
      title: newRecipe.title,
      image_url: newRecipe.imageURL,
      source_url: newRecipe.sourceURL,
      publisher: newRecipe.publisher,
      servings: +newRecipe.servings,
      ingredients,
      cooking_time: +newRecipe.cookingTime,
    };

    const data = await AJAX(`${API_URL}?key=${API_KEY}`, uploadData);
    const recipe = generateRecipeObject(data.data.recipe);

    return recipe;
  } catch (err) {
    throw err;
  }
}
